import HomePage from "/@/home/homepage.vue";
import ChangeLog from "/@/change_log/index.vue";
import Download from "/@/download/index.vue";
import Community from "/@/community/index.vue";
import News from "/@/news/index.vue";
import {ref} from "vue";
export const start_tab = 2;
export const activeTab=ref(start_tab)

export const tabs=[
    {name:"news",view:News},
    {name:"community",view:Community},
    {name:"menu",view:HomePage},
    {name:"download",view:Download},
    {name:"change_log",view:ChangeLog},
]
